export const numberFormat = new Intl.NumberFormat('sv-SE');
export const sek = new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' });
export const compact = new Intl.NumberFormat('sv-SE', {
  notation: 'compact',
  maximumFractionDigits: 1,
});
